export const MODE_CLOUD = 'cloud'
export const MODE_LOCAL = 'local'

export const PRESET_DOCS = 'docs'
export const PRESET_SHOPIFY = 'shopify'

export const COLOR_SCHEME_LIGHT = 'light'
export const COLOR_SCHEME_DARK = 'dark'
export const COLOR_SCHEME_SYSTEM = 'system'

export const SEARCH_INPUT_PLACEHOLDER_DEFAULT = 'Search...'
export const SEARCH_RESULTS_PLACEHOLDER_DEFAULT = 'Search something...'
export const NO_RESULTS_TEXT_VARIABLE = '@TERM@'
export const NO_RESULTS_TEXT_DEFAULT = `No results found for "${NO_RESULTS_TEXT_VARIABLE}"`

export const SHOW_FOOTER_KEYBOARD_SHORTCUTS = true
export const SHOW_POWERED_BY = true
export const RESULTS_NUMBER = 10

export const EVENT_SEE_ALL = 'orama-wc-searchbox:see-all'
export const EVENT_SEE_ITEM = 'orama-wc-searchbox:see-item'
export const EVENT_SHOW_SEARCHBOX = 'orama-wc-searchbox:show'

export const EVENT_SEARCH_BUTTON_CLICK = 'orama-wc-searchbutton:click'

export const PRESET_DOCS_SCHEMA = {
  title: 'string',
  content: 'string',
  path: 'string',
  section: 'string',
  category: 'enum',
  version: 'enum'
}

export const PRESET_SHOPIFY_SCHEMA = {
  title: 'string',
  tags: 'string[]',
  description: 'string',
  availableForSale: 'boolean',
  priceRange: {
    max: 'number',
    min: 'number'
  }
}

export const PresetSchemaMap = {
  [PRESET_DOCS]: PRESET_DOCS_SCHEMA,
  [PRESET_SHOPIFY]: PRESET_SHOPIFY_SCHEMA
}

export const DEFAULT_RETURNABLE_PROPS = {
  path: 'path',
  title: 'title',
  description: 'title',
  section: 'section',
  category: 'category'
}
